export const  TipoOrdenEnum  = Object.freeze({
    ABIERTA: 0,
    CERRADA_VIGENCIA: 1,
    CERRADA_CANTIDAD: 2,
})